

// about-us
export const section = '/api/sections'


//logo
export const logos = '/api/logo'

//logo
export const headerLogo = '/api/header-logo'


//footers

export const news = '/api/footers'

//footers

export const dataEntries = '/api/data-entries'

export const pdfLibraries = '/api/pdf-libraries'


export const sendEmail = '/api/send-email'


export const cookies = '/api/cookies'

export const cookiePopup = '/api/cookie-popups'


